import { Stack, Typography } from "@mui/material";
// import Info from "@mui/icons-material/Info";
import { useText } from "../../main.tsx";

const ProductHeadline: React.FC = () => {
    const { t } = useText();

    return (
        <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ mb: 2 }}
        >
            <Typography sx={{
                fontFamily: '"Sora", sans-serif',
                fontSize: 22,
                fontWeight: 600,
                color: "#1d1d1d",
            }}>
                {t('funnel.wizard.productList.title')}
            </Typography>
            {/*<Info sx={{ fontSize: 17, color: "#d9d9d9" }} />*/}
        </Stack>
    );
};

export default ProductHeadline;
